import {
  BaseEdge,
  EdgeLabelRenderer,
  getBezierPath,
  type EdgeProps,
} from "@xyflow/react";
import { Chip } from "@mui/material";
import type { PrepGraphEdge } from "../../../../types/prep";
import { useAppCustomStyles } from "../../../../assets/theme/custom/hooks";

type EdgeData = {
  graphEdge?: PrepGraphEdge;
  incomplete?: boolean;
};

export default function PrepCorrelationEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  label,
  markerEnd,
  style,
}: EdgeProps) {
  const edgeData = data as EdgeData | undefined;
  const custom = useAppCustomStyles();
  const joinType = edgeData?.graphEdge?.joinType ?? (typeof label === "string" ? label : "INNER");
  const incomplete = edgeData?.incomplete ?? false;
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={markerEnd}
        style={custom.components.dataPrep.correlationEdgeStyle(incomplete, style)}
      />
      <EdgeLabelRenderer>
        <Chip
          size="small"
          label={joinType}
          color={joinType === "LEFT" ? "default" : "primary"}
          variant={incomplete ? "outlined" : "filled"}
          sx={custom.components.dataPrep.correlationEdgeLabel(labelX, labelY, incomplete)}
        />
      </EdgeLabelRenderer>
    </>
  );
}
